import React from "react";
import { SectionTag } from "./ui/SectionTag";

export const AboutSection: React.FC = () => {
  return (
    <section
      className="flex justify-center bg-white py-12 lg:py-20"
      id="about"
    >
      <div className="flex flex-col gap-4 items-center md:items-start lg:items-center lg:gap-6">
        <SectionTag className="!mb-0 font-raleway">ABOUT US</SectionTag>

        <div className="flex flex-col gap-6 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-heading-large font-bold font-open-sans-hebrew text-center md:text-left">
              <span
                className="bg-gradient-to-r
         from-[#e20016] from-[0%]
         via-[#712f59] via-[40%]
         to-[#005d9c] to-[100%] bg-clip-text text-transparent tracking-[0.02em] w-full"
              >
                Built to deliver uncompromised performance
              </span>
            </h2>
          </div>

          <div className="flex max-md:flex-col max-md:gap-6 justify-between w-full">
            {/* Engineered Precision */}
            <div className="flex flex-col gap-2 items-center text-center md:items-start md:text-left lg:gap-4">
              <div
                className="w-6 h-6 bg-gradient-to-br from-[#dc2626] to-[#b91c1c]"
                style={{
                  maskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z'/%3E%3Cpath d='M22 17.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65'/%3E%3Cpath d='M22 12.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65'/%3E%3C/svg%3E\")",
                  WebkitMaskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z'/%3E%3Cpath d='M22 17.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65'/%3E%3Cpath d='M22 12.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65'/%3E%3C/svg%3E\")",
                  maskRepeat: "no-repeat",
                  WebkitMaskRepeat: "no-repeat",
                  maskPosition: "center",
                  WebkitMaskPosition: "center",
                  maskSize: "contain",
                  WebkitMaskSize: "contain",
                }}
              />
              <h3 className="text-card-title font-bold text-gray-900 font-raleway">
                Engineered Precision
              </h3>
              <p className="text-body text-gray-500 max-w-[150px] text-xs font-raleway">
                Uniform, calibrated construction
              </p>
            </div>
            {/* Trusted Durability */}
            <div className="flex flex-col gap-2 items-center text-center md:items-start md:text-left lg:gap-4">
              <div
                className="w-6 h-6 bg-gradient-to-br from-[#dc2626] to-[#b91c1c]"
                style={{
                  maskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='8' height='4' x='8' y='2' rx='1' ry='1'/%3E%3Cpath d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2'/%3E%3Cpath d='m9 14 2 2 4-4'/%3E%3C/svg%3E\")",
                  WebkitMaskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='8' height='4' x='8' y='2' rx='1' ry='1'/%3E%3Cpath d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2'/%3E%3Cpath d='m9 14 2 2 4-4'/%3E%3C/svg%3E\")",
                  maskRepeat: "no-repeat",
                  WebkitMaskRepeat: "no-repeat",
                  maskPosition: "center",
                  WebkitMaskPosition: "center",
                  maskSize: "contain",
                  WebkitMaskSize: "contain",
                }}
              />
              <h3 className="text-card-title font-bold text-gray-900 font-raleway">
                Trusted Durability
              </h3>
              <p className="text-body text-gray-500 max-w-[150px] text-xs font-raleway">
                Strong, long-lasting performance
              </p>
            </div>
            {/* Certified Quality */}
            <div className="flex flex-col gap-2 items-center text-center md:items-start md:text-left lg:gap-4">
              <div
                className="w-6 h-6 bg-gradient-to-br from-[#dc2626] to-[#b91c1c]"
                style={{
                  maskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z'/%3E%3Cpath d='m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18'/%3E%3Cpath d='m2.3 2.3 7.286 7.286'/%3E%3Ccircle cx='11' cy='11' r='2'/%3E%3C/svg%3E\")",
                  WebkitMaskImage:
                    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z'/%3E%3Cpath d='m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18'/%3E%3Cpath d='m2.3 2.3 7.286 7.286'/%3E%3Ccircle cx='11' cy='11' r='2'/%3E%3C/svg%3E\")",
                  maskRepeat: "no-repeat",
                  WebkitMaskRepeat: "no-repeat",
                  maskPosition: "center",
                  WebkitMaskPosition: "center",
                  maskSize: "contain",
                  WebkitMaskSize: "contain",
                }}
              />
              <h3 className="text-card-title font-bold text-gray-900 font-raleway">
                Certified Quality
              </h3>
              <p className="text-body text-gray-500 max-w-[150px] font-raleway ">
                BWP & ISI certified
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
